<script>

/**
 * @param manifest { Object }
 * @property manifest.disposal_report_amount { Number } 受入量
 * @property manifest.disposal_report_amount_unit_id { Number } 受入量の単位
 * @property manifest.disposal_report_driver { String } 運搬担当者
 * @property manifest.disposal_report_vehicle_number { String } 車両番号
 */
export default {
  name: "DisposalQuantityInformation",
  components: {},
  mixins: [],
  props: {
    manifest: {
      type: Object,
      default: () => null,
    },
    isFirstField: {
      type: Boolean,
      default: () => false,
    },
    callerType: {
      type: String,
      default: () => null,
    },
    quantityUnits: {
      type: Array,
      default: () => [],
    },
    drivers: {
      type: Array,
      default: () => [],
    },
    vehicles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      customMessages: {
        double: '数量は半角数字のみ使用できます'
      },
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  methods: {
    /**
     * 複写ボタン クリックイベント
     */
    copyFieldButtonClickEvent (property, value) {
      this.$emit('copyField', property, value);
    },
  }
}
</script>

<template>
  <div class="reportLayer">
    <v-row dense class="pb-3">
      <v-col cols="7">
        <h3>数量情報等</h3>
      </v-col>
      <v-col
        v-if="isFirstField"
        cols="5"
      >
        <v-btn
          block
          x-small
          style="visibility: hidden"
        >
        </v-btn>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12">
        <div class="field-with-copy">
          <validation-provider
            v-slot="{ errors }"
            :class="manifest.disposal_report_amount_unit_id > 0 ? 'requiredMark field-with-copy__control' : 'field-with-copy__control'"
            :disabled="!manifest.target_for_registration"
            :vid="`disposal_report_amount-${manifest.id}`"
            :rules="{
              required: manifest.disposal_report_amount_unit_id > 0,
              double: true,
              min_value: 0.001,
              max_value: 99999.999,
              quantityWithDecimal: { int_digits: 5, dec_digits: 3 }
            }"
            name="受入量"
            :custom-messages="customMessages"
          >
            <v-text-field
              v-model="manifest.disposal_report_amount"
              :disabled="!manifest.target_for_registration"
              :error-messages="errors"
              dense
              hide-details="auto"
              label="受入量"
              outlined
              reverse
              persistent-placeholder
              type="number"
              @keydown.69.prevent
            />
          </validation-provider>
          <div
            v-if="callerType !== 'bulk' && isFirstField"
            class="copy-actions"
          >
            <v-btn
              v-if="isFirstField"
              :disabled="!manifest.target_for_registration"
              color="primary"
              small
              @mousedown.stop.prevent
              @click.stop="copyFieldButtonClickEvent('disposal_report_amount', manifest.disposal_report_amount)"
            >
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <div class="field-with-copy">
          <validation-provider
            v-slot="{ errors }"
            :class="manifest.disposal_report_amount > 0 ? 'requiredMark field-with-copy__control' : 'field-with-copy__control'"
            :disabled="!manifest.target_for_registration"
            :rules="{ required: manifest.disposal_report_amount > 0 }"
            :vid="`disposal_report_amount_unit_id-${manifest.id}`"
            name="受入量の単位"
          >
            <v-select
              v-model="manifest.disposal_report_amount_unit_id"
              :disabled="!manifest.target_for_registration"
              :error-messages="errors"
              :items="quantityUnits"
              clearable
              dense
              hide-details="auto"
              label="受入量の単位"
              outlined
              persistent-placeholder
              style="font-size: 100%"
            />  
          </validation-provider>
          <div
            v-if="callerType !== 'bulk' && isFirstField"
            class="copy-actions"
          >
            <v-btn
              v-if="isFirstField"
              :disabled="!manifest.target_for_registration"
              color="primary"
              small
              @mousedown.stop.prevent
              @click.stop="copyFieldButtonClickEvent('disposal_report_amount_unit_id', manifest.disposal_report_amount_unit_id)"
            >
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row dense>
      <!-- 運搬担当者 -->
      <v-col cols="12">
        <div class="field-with-copy">
          <validation-provider
            v-slot="{ errors }"
            :disabled="!manifest.target_for_registration"
            :vid="`disposal_report_driver-${manifest.id}`"
            name="運搬担当者"
            rules="max:12"
            class="field-with-copy__control"
          >
            <v-combobox
              v-model="manifest.disposal_report_driver"
              :disabled="!manifest.target_for_registration"
              :error-messages="errors"
              :items="drivers"
              :return-object="false"
              dense
              label="運搬担当者"
              hide-details="auto"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>運搬担当者</span>
                <span class="ml-1">
                    ({{ manifest.disposal_report_driver?.length || 0 }} / 12)
                  </span>
              </template>
              <template v-slot:counter></template>
            </v-combobox>
          </validation-provider>
          <div
            v-if="callerType !== 'bulk' && isFirstField"
            class="copy-actions"
          >
            <v-btn
              v-if="isFirstField"
              :disabled="!manifest.target_for_registration"
              color="primary"
              small
              @mousedown.stop.prevent
              @click.stop="copyFieldButtonClickEvent('disposal_report_driver', manifest.disposal_report_driver)"
            >
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
      <!-- /運搬担当者 -->
    </v-row>
    <v-row dense>  
      <!-- 車両番号 -->
      <v-col cols="12">
        <div class="field-with-copy">
          <validation-provider
            v-slot="{ errors }"
            :disabled="!manifest.target_for_registration"
            :vid="`disposal_report_vehicle_number-${manifest.id}`"
            name="車両番号"
            rules="max:15"
            class="field-with-copy__control"
          >
            <v-combobox
              v-model="manifest.disposal_report_vehicle_number"
              :disabled="!manifest.target_for_registration"
              :error-messages="errors"
              :items="vehicles"
              :return-object="false"
              :clearable="true"
              dense
              item-text="number"
              item-value="number"
              label="車両番号"
              hide-details="auto"
              outlined
              persistent-placeholder
            >
              <template v-slot:label>
                <span>車両番号</span>
                <span class="ml-1">
                    ({{ manifest.disposal_report_vehicle_number?.length || 0 }} / 15)
                  </span>
              </template>
              <template v-slot:counter></template>
            </v-combobox>
          </validation-provider>
          <div
            v-if="callerType !== 'bulk' && isFirstField"
            class="copy-actions"
          >
            <v-btn
              v-if="isFirstField"
              :disabled="!manifest.target_for_registration"
              color="primary"
              small
              @mousedown.stop.prevent
              @click.stop="copyFieldButtonClickEvent('disposal_report_vehicle_number', manifest.disposal_report_vehicle_number)"
            >
              <v-icon>mdi-chevron-double-down</v-icon>
            </v-btn>
          </div>
        </div>
      </v-col>
      <!-- /車両番号 -->
    </v-row>
  </div>
</template>

<style scoped lang="scss">
.field-with-copy {
  display: flex;
  align-items: flex-start;
}

.field-with-copy__control {
  flex: 1;
  min-width: 0;
}

.copy-actions {
  padding-top: 4px;
}

</style>
